/// <amd-module name="Artifacts/Maven/Constants" />

export class MavenCiConstants {
  public static BuildLinkClicked = "BuildLinkClicked";
  public static CodeLinkClicked = "CodeLinkClicked";
  public static IssueLinkClicked = "IssueLinkClicked";
  public static LicenseLinkClicked = "LicenseLinkClicked";
  public static MavenDevelopment = "MavenDevelopment";
  public static OrganizationLinkClicked = "OrganizationLinkClicked";
}
